module.exports = __webpack_public_path__ + "static/14four-logo-2f80b780d0798d1020fd32429d0fd159.png";